module.exports = __webpack_public_path__ + "img/NoBooking.91b47ca1.png";